import type { TenantStatus } from '../api';

interface TenantStatusBadgeProps {
  status: TenantStatus;
}

const STATUS_CONFIG: Record<TenantStatus, { label: string; classes: string }> = {
  Active: { label: 'Activo', classes: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20' },
  Suspended: { label: 'Suspendido', classes: 'bg-amber-50 text-amber-700 ring-amber-600/20' },
  Blocked: { label: 'Bloqueado', classes: 'bg-rose-50 text-rose-700 ring-rose-600/20' },
  Pending: { label: 'Pendiente', classes: 'bg-slate-50 text-slate-600 ring-slate-600/20' },
};

export function TenantStatusBadge({ status }: TenantStatusBadgeProps): JSX.Element {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.Active;
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${config.classes}`}>
      {config.label}
    </span>
  );
}
